import styled from 'styled-components';
import { colors } from 'styles/colors';
import { shadows } from 'styles/remoteControlShadows';

export const EnergyConsumptionSpreadsheetContainer = styled.div`
  display: flex;
  flex-direction: column;
  // margin: 18px 16px;
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 16px;

  & > h1 {
    margin: 0;
    font-size: 20px;
    font-weight: 500;
    color: ${colors.text['main-900']};
    line-height: 130%;
  }
`;

export const CardContainer = styled.div`
  border: 0;
  margin-top: 24px;
  padding: 32px;
  padding-top: 24px;
  border-top: 8px solid ${colors.bg['primary-base']};
  border-radius: 5px;
  background-color: ${colors.bg['white-0']};
  box-shadow: ${shadows.shadow01};

  display: flex;
  flex-direction: column;

  & > h2 {
    margin: 0;
    padding: 0;
    font-weight: 600;
    font-size: 14px;
    line-height: 180%;
    color: ${colors.text['main-900']};
  }
`;

export const OrientationContainer = styled.div`
  padding: 16px;
  border-radius: 8px;
  background-color: ${colors.bg['soft-200']};
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 32px;
`;

export const OrientationContent = styled.div`
  display: flex;
  flex-direction: column;

  & > h3, & > span {
    margin: 0;
    padding: 0;
    font-size: 12px;
    color: ${colors.text['main-900']};
    line-height: 180%;
  }

  & > h3 {
    font-weight: 600;
  }

  & > span {
    font-weight: 400;
  }
`;

export const ExportInputsContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: start;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ButtonOutsideContainer = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FileOptionsContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  & > button {
    width: 278px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: start;

    & > button {
      width: 100%;
    }
  }
`;

export const OptionsButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  & > button {
    width: 168px;
    height: 33px;
  }

  @media (max-width: 768px) {
    width: 100%;

    & > button {
      width: auto;
      flex: 1;
    }
  }
`;

export const CheckboxContainer = styled.div`
  margin-top: 4px;
  display: flex;
  gap: 8px;
  height: 22px;

  span {
    user-select: none;
    font-weight: 600;
    font-size: 12px;
    line-height: 180%;
    color: ${colors.text['main-900']};
  }
`;
